<div class="wrap">
  <app-svg-icon [name]="'close'" (click)="onDismiss()" class="close-icon"></app-svg-icon>
  <app-svg-icon
    class="info-icon"
    [name]="'info'"
    [color]="'color-state-warning'"
  ></app-svg-icon>
  <div class="text">
    <div class="line first">
      {{ "@components.subsidyInfoModal.firstLine" | translate }}
    </div>
    <app-price-label
      [value]="subsidyAmount | appCurrency | async"
      [noIcon]="true"
      [secondaryCurrencyAlight]="'inline'"
    ></app-price-label>
    <div class="line last">
      {{ "@components.subsidyInfoModal.secondLine" | translate }}
    </div>
    <div class="additional-info">
      {{ "@components.subsidyInfoModal.additionalInfo" | translate }}
    </div>
  </div>
</div>
